<template>
  <v-menu
    v-if="items.length"
    offset-y
    rounded="lg"
    :top="floating"
    :left="floating"
  >
    <template #activator="{ on: menu, attrs }">
      <!-- Móvil: botón flotante, solo con encuestas por responder. -->
      <div
        v-if="floating"
        v-show="available.length"
        class="tw-fixed tw-bottom-20 tw-right-4 tw-z-40"
      >
        <v-badge :content="available.length" color="green" overlap>
          <v-btn fab color="primary" v-bind="attrs" v-on="menu">
            <GIcon name="clipboard_check" class="tw-h-6 tw-w-6" />
          </v-btn>
        </v-badge>
      </div>
      <v-tooltip v-else bottom>
        <template #activator="{ on: tooltip }">
          <v-btn
            class="tw-bg-transparent tw-font-bold tw-normal-case tw-text-gray-800 tw-shadow-none focus:tw-outline-none focus:tw-ring focus:tw-ring-gray-50"
            color="white"
            rounded
            fab
            small
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
          >
            <v-badge
              :content="available.length"
              :value="available.length"
              color="green"
              overlap
            >
              <GIcon name="clipboard_check" class="tw-h-6 tw-w-6" />
            </v-badge>
          </v-btn>
        </template>
        <span>{{ $t('bz2.event.surveys.title') }}</span>
      </v-tooltip>
    </template>

    <v-card max-width="380" width="380" class="tw-p-2">
      <p class="text-overline tw-mb-0 tw-px-3 tw-pt-2">
        {{ $t('bz2.event.surveys.title') }}
      </p>
      <v-list dense class="tw-max-h-96 tw-overflow-y-auto">
        <v-list-item
          v-for="survey in items"
          :key="survey.uuid"
          :disabled="!canAnswer(survey)"
          @click="open(survey)"
        >
          <v-list-item-icon class="tw-mr-3">
            <v-icon :color="icon(survey).color">{{ icon(survey).name }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="tw-whitespace-normal">
              {{ survey.title }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ statusLabel(survey) }}
              <template v-if="survey.speaker"> · {{ survey.speaker }}</template>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import GIcon from '@/components/GIcon.vue'

// Ícono de encuestas en la barra del evento, junto al de notificaciones: las
// encuestas del día, bloqueadas hasta que el admin activa cada una. El número
// son las activas sin responder.
export default {
  components: {
    GIcon,
  },
  props: {
    // Móvil: la barra superior no existe, se muestra como botón flotante.
    floating: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      items: (state) => state.surveys.items,
    }),
    ...mapGetters({
      available: 'surveys/available',
    }),
  },
  methods: {
    canAnswer(survey) {
      return survey.status === 'open' && !survey.answered
    },
    open(survey) {
      if (this.canAnswer(survey)) {
        this.$store.dispatch('surveys/open', survey)
      }
    },
    icon(survey) {
      if (survey.answered) {
        return { name: 'check_circle', color: 'green' }
      }
      return {
        open: { name: 'assignment', color: 'primary' },
        closed: { name: 'block', color: 'grey' },
      }[survey.status] || { name: 'lock', color: 'grey' }
    },
    statusLabel(survey) {
      if (survey.answered) {
        return this.$t('bz2.event.surveys.answered')
      }
      return this.$t(`bz2.event.surveys.status.${survey.status}`)
    },
  },
}
</script>
